import React from "react";
import { useTranslation } from 'react-i18next';

const Totals = ({crewCart, currencyFormatter, loading}) => {



    const { t } = useTranslation();
    return (
        <div class={"pt-1"}>
            <style>
                {`
                .justify-between{
                justify-content:space-between;
                display:flex;
                }
                `}
            </style>
            <div className="flex justify-between items-center">
                <div>
                    <strong className="text-lg">{t('cartItems.totalDiscount')}</strong>
                </div>
                <div>
                    <strong className="text-lg">
                        {currencyFormatter?.format((crewCart.checkout_total ?? 0) - (crewCart.order_total ?? crewCart.order_total))}
                    </strong>
                </div>
            </div>
            <div className="flex justify-between items-center">
                <div>
                    <strong className="text-lg">{t('cartItems.total')}</strong>
                </div>
                <div>
                    <strong
                        className="text-lg">{loading ? '___' : currencyFormatter?.format(Number(crewCart?.order_total)) ?? Number(crewCart?.order_total).toFixed(2)}</strong>
                </div>
            </div><br />
        </div>
    );
}

export default Totals;
